import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { AudioFile, AudioFileRule, AudioFileNumberOfReplays, SectionSummary } from '../../../../core';
export var SectionSummaryApiMapper = /*#__PURE__*/function () {
  function SectionSummaryApiMapper() {
    _classCallCheck(this, SectionSummaryApiMapper);
  }

  _createClass(SectionSummaryApiMapper, [{
    key: "toDomain",
    value: function toDomain(formId, sectionSummaryDto) {
      return SectionSummary.create({
        id: sectionSummaryDto.id,
        formId: formId,
        title: sectionSummaryDto.title,
        description: sectionSummaryDto.description,
        totalScore: sectionSummaryDto.totalScore,
        totalQuestion: sectionSummaryDto.totalQuestion,
        index: sectionSummaryDto.index,
        previousSectionId: sectionSummaryDto.previousSectionId,
        displayType: sectionSummaryDto.displayType,
        audioFile: sectionSummaryDto.audioFile ? AudioFile.create({
          url: sectionSummaryDto.audioFile.url,
          type: sectionSummaryDto.audioFile.type,
          size: sectionSummaryDto.audioFile.size,
          rule: sectionSummaryDto.audioFile.rule ? AudioFileRule.create(_objectSpread(_objectSpread({}, sectionSummaryDto.audioFile.rule), {}, {
            numberOfReplays: AudioFileNumberOfReplays.create(sectionSummaryDto.audioFile.rule.numberOfReplays).getValue()
          })).getValue() : undefined
        }, sectionSummaryDto.audioFile.id).getValue() : undefined
      }).getValue();
    }
  }]);

  return SectionSummaryApiMapper;
}();